import { ILLCompany, ILLRelationship } from './index';

export class ILLEstablishment {
 establishmentCompany: ILLCompany;
 confidentiality: string;
 businessOperations: ILLRelationship[];
}
